// TODO: Move sharing to src/common/component/
(function () {
  'use strict'

  require('./scss/sharing.scss')

  var MODULE_NAME = 'thismoment.card.component.sharing'
  var templateUrl = require('./tpl/sharing.html')
  var popoverTemplateUrl = require('./tpl/sharing-popover.html')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-animate'),
      require('angular-ui-bootstrap/src/popover/index-nocss.js'),
      require('../../analytics'),
      require('../../content')
    ])
    // TODO: Make bindings agree across all components... they should either be 'ccmt{Content,Playlist}Id' or '{content,playlist}Id', but not both
    .component('thismomentSharing', {
      bindings: {
        analyticsProps: '<',
        ccmtContentId: '<',
        customStyles: '<',
        item: '<',
        playlistId: '<'
      },
      templateUrl: templateUrl,
      controller: sharingController
    })

  sharingController.$inject = ['$httpParamSerializer', 'analyticsSDK', 'SdkConfig']
  function sharingController ($httpParamSerializer, analyticsSDK, SdkConfig) {
    var vm = this

    vm.$onInit = sharingInit

    function sharingInit () {
      var queryParams = {
        playlistId: vm.playlistId,
        contentId: vm.item.id
      }
      var shareUrl = encodeURIComponent(SdkConfig.get('host_url') + '?' + $httpParamSerializer(queryParams))
      var title = encodeURIComponent(vm.item.title)

      vm.contentId = vm.item.id
      vm.trackEvent = analyticsSDK.setupEventTracking(vm.analyticsProps)

      if (vm.customStyles.hasOwnProperty('color')) {
        vm.styles = {
          icon: {
            color: vm.customStyles.color
          }
        }
      }

      vm.url = {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(SdkConfig.get('content_cloud_url') + '/v1/api/share_page?account_id=' + SdkConfig.get('account_id') + '&content_id=' + vm.item.id + '&url=' + shareUrl),
        twitter: 'https://www.twitter.com/share?text=' + title + '&url=' + shareUrl,
        email: 'mailto:?subject=' + title + '&body=' + title + '%0D%0A %0D%0A' + shareUrl,
        pinterest: 'http://pinterest.com/pin/create/button/?url=' + shareUrl + '&media=' + encodeURIComponent(vm.item.images.original.url) + '&description=' + title
      }

      vm.isTwitter = (vm.item.source.source_name === 'twitter')
      if (vm.isTwitter) {
        vm.sourceId = vm.item.source.origin_id
      }

      vm.popover = {
        templateUrl: popoverTemplateUrl
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/sharing.js